import React, { useState } from 'react';
import { IoChevronDown } from 'react-icons/io5';
import '../../pages/Settings/Settings.css';

interface CollapsibleSectionProps {
  title: string;
  description?: string;
  defaultExpanded?: boolean;
  children: React.ReactNode;
  className?: string;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  description,
  defaultExpanded = false,
  children,
  className = '',
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  return (
    <div className={`settings-section ${className}`}>
      <div
        className="settings-section-header"
        onClick={() => setIsExpanded(!isExpanded)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setIsExpanded(!isExpanded);
          }
        }}
        aria-expanded={isExpanded}
      >
        <div>
          <h3 className="settings-section-title">{title}</h3>
          {description && (
            <p className="settings-section-description">{description}</p>
          )}
        </div>
        <IoChevronDown
          className={`settings-chevron ${isExpanded ? 'expanded' : ''}`}
          style={{
            transition: 'transform 0.3s ease',
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        />
      </div>
      {isExpanded && (
        <div
          className="settings-section-content"
          style={{
            animation: 'slideDown 0.3s ease',
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
